import React, { Component } from "react";
import uniqueId             from 'lodash/uniqueId';
import { Colors }           from "../../utils/Colors";
import "../../css/utils/SideNavReminderList.css";

export default class SideNavTimelineWeek extends Component {

    constructor(props) {
        super(props);

        this.state = {
            week_current: this.props.week_current,
            total_weeks: this.props.total_weeks,
            openSideNav: true,
            showDayView: "none"
        }
    }

    componentWillReceiveProps (nextProps) {
        var total_weeks  = nextProps.total_weeks;
        var week_current = nextProps.week_current;
        var showDayView  = nextProps.showDayView;
        var scrollYPos   = nextProps.scrollYPos;
        var days_id_order= nextProps.days_id_order;

        // debug: if(total_weeks != null)
        //    console.log("+++++++++++++ 2. total weeks: " + Object.keys(total_weeks).length);

        if(showDayView === "none" && total_weeks != null) {
            var num_weeks = 0;

            num_weeks = Object.keys(total_weeks).length
            week_current = this.getCurrentWeek(num_weeks, scrollYPos);
        }

        this.setState({
            total_weeks:  total_weeks,
            week_current: week_current,
            showDayView:  showDayView,
            days_id_order: days_id_order
        })
    }

    getCurrentWeek = (num_weeks, scrollYPos) => {
        var week_current = 1;

        for(var i=0; i < num_weeks; i++) {
            var val = 770*i; // vals can't be higher than 800 or lower than 650
            var val2 = val+1000;
            if(scrollYPos > val && scrollYPos < val2) week_current = i+1;
        }

        return week_current;
    }

    scrollToWeekView = (week_num, week_id) => {
        var showDayView = this.state.showDayView

        if(showDayView === "none") {
            var el = document.getElementById("week_"+week_num)
            el.scrollIntoView({ behavior: 'smooth' });
        } else {
            //console.log(">>>>>>>>>>>>>>>>>>> week_id: " + week_id + " >>>>>>>>>>>>");
            //console.log(">>>>>>>>>>>>>>>>>>> week_num: " + week_num + " >>>>>>>>>>>>");
            /*var day_id;
            var days_id_order = this.state.days_id_order
            for (var key in days_id_order) {
                /*console.log("Ctr key: " + key);
                console.log("data uid: " + days_id_order[key].uid);
                console.log("data day: " + days_id_order[key].day);
                if(key == 0) {
                    day_id = days_id_order[key].uid;
                    console.log("HIIIIT new DAY ID = " + days_id_order[key].uid);

                }
            }*/
            this.props.handleWeekDropdownChange(0, week_num, week_id)
        }

        //this.props.

        this.setState({
            week_current: week_num
        })
    }

    closeSideNavTimeline = () => {
        this.setState(prevState => ({
            openSideNav: !prevState.openSideNav
        }));
    }

    render() {
        var total_weeks = this.state.total_weeks;
        var week_current = this.state.week_current;
        var weeks;
        var openSideNav = this.state.openSideNav;
        var sidenav_height  = "70%";
        var display_subcont = "inline" ;

        if(!openSideNav) {
            sidenav_height = "40px";
            display_subcont = "none";
        }

        if(total_weeks != null)
            weeks =  Object.keys(total_weeks).map(function (key) {
                                var week_num = parseInt(key) + 1;
                                var week_id = total_weeks[key].uid;
                                var bgcolor;
                                (week_current === week_num ? bgcolor= Colors.secondary_color : null)
                                        return (
                                            <div key={uniqueId()}>
                                                <div className = {(week_current === week_num ? "sideNavTimelineCircle_active" : "sideNavTimelineCircle")}
                                                     style     = {{backgroundColor: bgcolor}}
                                                     onClick={() => this.scrollToWeekView(week_num, week_id)}
                                                >
                                                    <b style={{color:"#000"}}>{ week_num }</b>
                                                </div>
                                                <div className="sideNavTimelineVertBar"/>
                                            </div>
                                        )
                                }, this)

        return (
            <div className="sideNavReminderListContainer" style={{height: sidenav_height, transition: "all .5s ease"}}>
                <div className = "closeSideNavReminder"
                     onClick   = {this.closeSideNavTimeline}>
                    <span className="glyphicon glyphicon-align-justify" />
                </div>
                <div className="sideNavTimelineSubContainer" style={{display: display_subcont}}>
                    <div className="sideNavTimelineTitle">WK</div>
                        { weeks }
                    <div className="sideNavTimelineCirclePlus"
                         onClick={() => this.props.addNewWeekFromMonthView()}>
                        <b>+</b>
                    </div>
                </div>

            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/utils/SideNavReminderList.js